import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  size?: 'small' | 'normal' | 'large';
}

export default function MovieCard({ movie, size = 'normal' }: MovieCardProps) {
  const sizeClasses = {
    small: 'w-[160px]',
    normal: 'w-[200px]',
    large: 'w-[240px]',
  };

  return (
    <Link
      to={`/category/${movie.categorySlug}`}
      className={`${sizeClasses[size]} group cursor-pointer block flex-shrink-0`}
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 免费电影在线观看`}
          title={`${movie.title} - 高清免费电影`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-transparent to-transparent" />

        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {movie.isNew && (
            <span className="px-2 py-0.5 rounded text-xs font-semibold bg-primary-500 text-background-50 whitespace-nowrap">
              新
            </span>
          )}
          {movie.isHot && (
            <span className="px-2 py-0.5 rounded text-xs font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
              热播
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 rounded text-xs font-semibold bg-background-50/80 text-primary-600 whitespace-nowrap">
            {movie.rating}
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-foreground-950 truncate">{movie.title}</h3>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-xs text-foreground-500">{movie.year}</span>
            <span className="text-xs text-foreground-400">·</span>
            <span className="text-xs text-foreground-500 truncate">{movie.category}</span>
          </div>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 rounded-full bg-accent-500/90 flex items-center justify-center">
            <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}